$(function () {
  let groupByClass = {};
  let clickedAppearGroup = $("[class^='clickedAppearGroup']");
  $(clickedAppearGroup).each(function(i, group){
    let className = $(group).attr('class').match(/clickedAppearGroup\d+/)[0];
    if (groupByClass[className]) {
      groupByClass[className].push(group);
    } else {
      groupByClass[className] = [group]
    }
  });

  // 各グループのTOP要素以外は非表示にする
  Object.keys(groupByClass).forEach(function(key) {
    let val = this[key];
    $(val).each(function(i) {
      if (i != 0) {
        $(this).hide();
      }
    });
  }, groupByClass);

  // clickでフォーム表示
  $('.clickedAppearBtn').on('click', function() {
    $(this).parent().find(".clickedAppear").removeClass("clickedAppearHidden");
    $(this).hide();
    
    // グループの中で順番に表示
    let groupClass = $(this).attr('class').match(/clickedAppearGroup\d+/);
    if (groupClass) {
      let className = groupClass[0]
      groupByClass[className].shift();

      // 同じsubgroupを表示
      let subgroupClass = $(this).attr('class').match(/clickedAppearSubgroup\d+/);
      if (subgroupClass) {
        let subgroupName = subgroupClass[0];
        $(groupByClass[className]).each(function(i, elem){
          if ($(elem).attr('class').match(subgroupName)) {
            $(elem).parent().find(".clickedAppear").removeClass("clickedAppearHidden");
            groupByClass[className].splice(i, 1)
          }
        });
      }
      
      //次のボタン表示
      $(groupByClass[className][0]).show();
    }
  });
});
